import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getPersonPotentialMatchesData from './GetPersonPotentialMatchesData';
import putPersonPotentialMatchesData from './PutPersonPotentialMatchesData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const PersonPotentialMatchData = {
  INITIAL_STATE,
  getPersonPotentialMatchesData,
  putPersonPotentialMatchesData
};

export default PersonPotentialMatchData;